import React from "react";

const StatisticsSkeleton = () => {
  // Create an array of 8 placeholder items to simulate the grid
  const skeletonItems = Array.from({ length: 8 });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 animate-pulse">
      {skeletonItems.map((_, index) => (
        <div
          key={index}
          className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
        >
          <div className="flex items-start justify-between">
            <div className="space-y-3 w-full">
              {/* Position Name Placeholder */}
              <div className="h-4 bg-gray-200 rounded w-1/3"></div>

              {/* Count Placeholder */}
              <div className="h-8 bg-gray-200 rounded w-1/4"></div>

              {/* Label Placeholder */}
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
            </div>

            {/* Icon Placeholder */}
            <div className="w-12 h-12 bg-gray-200 rounded-xl"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsSkeleton;
